// Author Eric
// Date 2020-09-18 09:17:41

class SithMesAndonPosition {
constructor({
        id = null,
        name = '',
        parentId = '',
        seq = '',
        andonUpgradeTime = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.parentId = parentId;
    this.seq = seq;
    this.andonUpgradeTime = andonUpgradeTime;
}
}

function newEntity() {
return new SithMesAndonPosition();
}

function gridFields() {
return Object.freeze([
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonPosition.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.sith.andon.sithMesAndonPosition.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.sith.andon.sithMesAndonPosition.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'level',
        label: 'label.sith.andon.sithMesAndonPosition.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.andon.sithMesAndonPosition.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.andon.sithMesAndonPosition.grid.seq',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'andonUpgradeTime',
        label: 'label.sith.andon.sithMesAndonPosition.grid.andonUpgradeTime',
        sortable: true,
        form: {
        type: 'input'
        }
        }
]);
}

const filter = {
    nameFilter : "",
    parentIdFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    andonUpgradeTimeFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.andon.sithMesAndonPosition.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentIdFilter',
        label: 'label.sith.andon.sithMesAndonPosition.filter.parentId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonPosition'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'andonUpgradeTimeFilter',
        label: 'label.sith.andon.sithMesAndonPosition.filter.andonUpgradeTime',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.andon.sithMesAndonPosition.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'parentId',
        label: 'label.sith.andon.sithMesAndonPosition.entity.parentId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesAndonPosition'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'andonUpgradeTime',
        label: 'label.sith.andon.sithMesAndonPosition.entity.andonUpgradeTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        }
]

export {SithMesAndonPosition, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
